import {StringPatternSchema} from 'favorlogic-utils';

import {validationRegularExpressions} from 'utils/DairyValidator';

export const MilkRoomCodeSchema = StringPatternSchema(validationRegularExpressions.milkRoomCode);

export type MilkRoomCode = string;
